import React from 'react';
import DirectToResource from '../DirectToResource';

import styles from './styles.module.scss';
import { can, permActions } from '../../permissions';

const Home = ({ loggedInUser }) => {
  const showPurchaseSearch = can(loggedInUser, permActions.VIEW_PURCHASES);
  return (
    <div className="Home">
      <h1>Wing Admin Home</h1>
      <br />
      <hr />
      <div className={styles.items}>
        <div className={styles.item}>
          <h4>Go directly to user</h4>
          <DirectToResource url={(id) => `/users/${id}/view`} label="User ID" />
        </div>
        <div className={styles.item}>
          <h4>Go directly to Simo subscription</h4>
          <DirectToResource
            url={(id) => `/simo/subscriptions/${id}/view`}
            label="Subscription ID"
          />
        </div>
        <div className={styles.line}></div>
        <div className={styles.item}>
          <h4>Go directly to AT&amp;T subscription</h4>
          <DirectToResource
            url={(id) => `/att/subscriptions/${id}/view`}
            label="Subscription ID"
          />
        </div>
        <div className={styles.item}>
          <h4>Go directly to Quick subscription</h4>
          <DirectToResource
            url={(id) => `/quick/subscriptions/${id}/view`}
            label="Subscription ID"
          />
        </div>
        <div className={styles.line}></div>
        {showPurchaseSearch && (
          <>
            <div className={styles.item}>
              <h4>Go directly to Purchase</h4>
              <DirectToResource
                url={(id) => `/purchases/${id}/view`}
                label="Purchase ID"
              />
            </div>
            <div className={styles.line}></div>
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
